import Event from "./EventPage";
export default Event;
